module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content waste_collection_wrp"
  }, [_c('div', {
    staticClass: "main_select_wrp_relative main_select_wrp_vechile"
  }, [_c('div', {
    staticClass: "modal fade model_modify_wrp",
    attrs: {
      "id": "filtertoogle",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', [_vm._v("Filters")]), _vm._v(" "), _c('button', {
    staticClass: "close clearButton",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear\n              All")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "main_select_wrp"
  }, [_c('div', {
    staticClass: "flex selectwca_wrp"
  }, [_c('div', {
    staticClass: "multiselected"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('multiselect', {
    key: _vm.status.length,
    attrs: {
      "track-by": "value",
      "label": "name",
      "placeholder": "Select Status",
      "options": _vm.status,
      "name": "status",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": ""
    },
    on: {
      "select": _vm.onSelectStatus,
      "remove": _vm.onRemoveStatus
    },
    model: {
      value: (_vm.clearFilters.status.value),
      callback: function($$v) {
        _vm.$set(_vm.clearFilters.status, "value", $$v)
      },
      expression: "clearFilters.status.value"
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "word_details_wrp",
    class: _vm.addButtonClass
  }, [_c('div', {
    staticClass: "filter_wrpp"
  }, [_c('button', {
    staticClass: "btn gradientbt",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#filtertoogle"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:cc": "http://creativecommons.org/ns#",
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0 -1028.4)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m10 11v10l4 3v-13h-4z",
      "fill": "#fff",
      "transform": "translate(0 1028.4)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m10 11v10l2 1.5v-11.5h-2z",
      "fill": "#fff",
      "transform": "translate(0 1028.4)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m1 1028.4 9 11h4l9-11z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m1 1028.4 9 11h2v-11z",
      "fill": "#fff"
    }
  })])]), _vm._v("Apply Filter\n            "), _c('span', {
    class: {
      'counter_filter': _vm.count
    }
  }, [_vm._v(_vm._s(_vm.count))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'wasteCollectionAreaCreate',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('button', {
    staticClass: " btn gradientbt"
  }, [_vm._v("Add Zone")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "wasteCollectionAreaCreateTable",
    staticClass: "table_wrp",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between collection_division_wrp collection_division_width"
        }, [_c('a', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.action(props.row)
            }
          }
        }, [_vm._v("\n              Collection Division\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "py-2 text-center row"
        }, [_c('label', {
          staticClass: "toggle"
        }, [_c('input', {
          staticClass: "toggle-checkbox",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.status
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.activateWasteModal(props.row); })($event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "slider"
        })])])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-066a746c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066a746c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteCollectionArea/wasteCollectionArea.vue
// module id = 2248
// module chunks = 0